import { useMemo, useState } from "react"

import getDefaultAmount from "./getDefaultAmount"

const useAmountByKey = (items, distributionFrequency, shouldRoundCents) => {
  const [ customAmountByKey, setCustomAmountByKey ] = useState({})

  const amountByKey = useMemo(() =>
    items.reduce((accumulator, item) => {
      accumulator[item.key] = customAmountByKey[item.key] !== undefined
        ? customAmountByKey[item.key]
        : getDefaultAmount(item, distributionFrequency, shouldRoundCents)

      return accumulator
    }, {})
  , [ items, customAmountByKey, distributionFrequency, shouldRoundCents ])

  return { amountByKey, customAmountByKey, setCustomAmountByKey }
}

export default useAmountByKey
